import script from "./LicenceModification.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenceModification.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__